module.exports = __webpack_public_path__ + "static/img/mobiscope-logo.5cadf19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/mobiscope-logo.png
// module id = 1458
// module chunks = 0